import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  SubmitButton,
} from "@ameelio/ui";
import { Stack } from "@mui/material";
import { FormEventHandler, ReactNode } from "react";
import { useTranslation } from "react-i18next";

type Props = {
  title: string;
  onClose: () => void;
  onSubmit: FormEventHandler<HTMLFormElement>;
  submitting: boolean;
  submitDisabled?: boolean;
  submitLabel?: string;
  cancelLabel?: string;
  onDelete?: () => void;
  deleteLabel?: string;
  children: ReactNode;
};

export default function FormDialog({
  title,
  onClose,
  onSubmit,
  submitting,
  submitDisabled,
  submitLabel,
  cancelLabel,
  onDelete,
  deleteLabel,
  children,
}: Props) {
  const { t } = useTranslation();

  return (
    <Dialog title={title} onClose={onClose} fullWidth>
      <form onSubmit={onSubmit}>
        <DialogContent sx={{ pt: 0 }}>
          <Stack spacing={2} sx={{ pt: 2 }}>
            {children}
          </Stack>
        </DialogContent>
        <DialogActions sx={{ p: 2, pt: 0 }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ justifyContent: "space-between", width: "100%" }}
          >
            {onDelete ? (
              <Button variant="text" color="error" onClick={onDelete}>
                {deleteLabel ?? t("Delete")}
              </Button>
            ) : (
              <span />
            )}
            <Stack direction="row" spacing={1}>
              <Button variant="outlined" onClick={onClose}>
                {cancelLabel ?? t("Cancel")}
              </Button>
              <SubmitButton submitting={submitting} disabled={submitDisabled}>
                {submitLabel ?? t("Save")}
              </SubmitButton>
            </Stack>
          </Stack>
        </DialogActions>
      </form>
    </Dialog>
  );
}
